// extracted by css-extract-rspack-plugin
export default {"iconContainer":"Palette-module__iconContainer___YdGdD","viewAndFilterResults":"Palette-module__viewAndFilterResults___MeOa2"};